import axios from "./axios";

class RechargeService {
  transaction = async (number, operator, amount, route) => {
    try {
      const response = await axios.post("/recharge/transaction", {
        number,
        operator,
        amount,
        route,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  fetchOperator = async (mobile) => {
    try {
      const response = await axios.post("/recharge/fetch_operator", { mobile });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  dthCustomerInfo = async (number, operator) => {
    try {
      const response = await axios.post("/recharge/dth_customer_info", {
        number,
        operator,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  plans = async (number, operator, circle) => {
    try {
      const response = await axios.post("/recharge/plans", {
        number,
        operator,
        circle,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  getCommercial = async (number, operator, amount, is_bbps) => {
    try {
      const response = await axios.post("/recharge/get_commercial", {
        number,
        operator,
        amount,
        is_bbps,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new RechargeService();
